import React, { Component } from 'react';
import { connect } from 'react-redux';
import RoomsList from './Rooms/RoomsList';
import SearchBox from './SearchBox';
import ErrorBoundry from './Components/ErrorBoundry'
import Header from './Components/Header'
import Particles from 'react-particles-js';
import Modal from './Modal/Modal';
import RoomDetails from './RoomDetails/RoomDetails'
import Register from './Register/Register'
import './App.css';

import { setSearchField, requestRooms, setToggleModal } from './actions';

const particleOpt = {
  particles: {
    number: {
      value: 30,
      density: {
        enable: true,
        value_area:800
      }
    }
  }
}

const mapStateToProps = state => {
	return {
		searchField: state.searchRooms.searchField,
		rooms: state.requestRooms.rooms,
		isPending: state.requestRooms.isPending,
		error: state.requestRooms.error,
		isOn: state.toggleModal.isOn,
		id: state.toggleModal.id
	}
}

const mapDispatchToProps = (dispatch) => {
	return {
		onSearchChange: (event) => dispatch(setSearchField(event.target.value)),
		onRequestRooms: () => dispatch(requestRooms()),
		onToggleModal: (id) => dispatch(setToggleModal(id))
	}	
}

class App extends Component {
	constructor() {
    super();
    this.state = {
    	value: 'name',
    	register: false   	
    };

	}

	handleChange = (event) => {
		this.setState({value: event.target.value});
  	}

  	handleRegister = () => {
  		this.setState({register: false})
  	}
	
	componentDidMount() {
	 	this.props.onRequestRooms()	
	 }

	render() {		
		const { value, register } = this.state;		
		const { searchField, onSearchChange, rooms, isPending, onToggleModal, isOn, id } = this.props;		
		
		const filteredRooms = rooms.filter(room => { 
			return room[value].toLowerCase().includes(searchField.toLowerCase())
		})

		return isPending ? 
			<h1>Loading page</h1> 
			: register ? 
			<Register handleRegister={this.handleRegister}/>
			:( <div className="App, tc">
		      	<Header roomplayed = {rooms.length} />
		      	<SearchBox searchChange = {onSearchChange}/>
		      	<select value={this.state.value} onChange={this.handleChange}>
					<option aria-label='name' value = "name">Name</option>
					<option aria-label='company' value = "company">Company</option>
					<option aria-label='location' value = "location">Location</option>
				</select>				
				{ isOn && 
					<Modal>
						<RoomDetails toggleModal={onToggleModal} Esrooms = {rooms} id = {id}/>						
					</Modal>
				}
		      	<ErrorBoundry>
		        	<RoomsList Esrooms = { filteredRooms } toggleModal={onToggleModal} />
		        </ErrorBoundry>
		        <Particles className='particles' params ={particleOpt}/>	        
		      </div>
	    );
	  }  
  
}

export default connect(mapStateToProps, mapDispatchToProps)(App);



// WEBPACK FOOTER //
// ./src/App.js